import React, { useEffect, useState } from "react";
import { getMenuItemscountryTo } from "../../../constent/countries";
import { useTranslation } from "react-i18next";
import { getMenuItemsWeights } from "../../../constent/weight";
import ShippingCompaniesTableDetails from "./ShippingCompaniesTableDetails";
import { useDispatch } from "react-redux";
import {
  CreateShipmentCost,
  GetShipmentCost,
  UpdateShipmentCost,
} from "../../../redux/reducer/shipmentCostReducer";

const ShippingCompaniesSettings = ({ companies, zone }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [tableResultText, setTableResultText] = useState(null);
  const [resultText, setResultText] = useState(null);
  const [selectedWeight, setSelectedWeight] = useState();
  const [selectedCampany, setSelectedCampany] = useState();
  const [editableCountries, setEditableCountries] = useState(
    getMenuItemscountryTo()
  );

  const menuItemsWeights = getMenuItemsWeights(t);
  useEffect(() => {
    const fetchCost = async () => {
      if (selectedWeight && selectedCampany) {
        const shipmentData = {
          weight: selectedWeight,
          companyName: selectedCampany,
          zone: zone.en,
        };

        const resultAction = await dispatch(GetShipmentCost(shipmentData));

        if (GetShipmentCost.fulfilled.match(resultAction)) {
          setResultText(resultAction.payload);
          setTableResultText(resultAction.payload);
        } else {
          setResultText("");
          setTableResultText(null);
        }
      }
    };

    fetchCost();
  }, [selectedWeight, selectedCampany, dispatch]);

  useEffect(() => {
    if (resultText && resultText.countries?.length > 0) {
      const updatedCountries = editableCountries.map((country) => {
        const matched = resultText.countries.find(
          (c) => c.en.toLowerCase() === country.en.toLowerCase()
        );
        return {
          ...country,
          cost: matched ? matched.cost : country.cost || 0,
        };
      });

      setEditableCountries(updatedCountries);
    }
  }, [resultText]);

  const handleCostCreate = (index, newCost) => {
    const updated = [...editableCountries];
    updated[index].cost = newCost;
    setEditableCountries(updated);
  };

  const handleSubmitSend = () => {
    const countries = editableCountries.map((country) => ({
      en: country.en,
      ar: country.ar,
      cost: parseFloat(country.cost) || 0,
    }));

    const payload = {
      companyName: selectedCampany,
      weight: Number(selectedWeight),
      zone,
      countries,
    };

    // console.log('Payload to send:', payload);
    dispatch(CreateShipmentCost(payload))
      .unwrap()
      .then(() => {
        setSelectedWeight("");
      })
      .catch((error) => alert(error || "Failed to Create ShipmentCost ."));
  };

  const handleCostChange = (index, newCost) => {
    const updated = [...editableCountries];
    updated[index].cost = newCost;
    setEditableCountries(updated);
  };

  const handleSubmitUpdate = () => {
    const countries = editableCountries.map((country) => ({
      en: country.en,
      ar: country.ar,
      cost: parseFloat(country.cost) || 0,
    }));

    const payload = {
      countries,
    };

    dispatch(UpdateShipmentCost({ shipmentData: payload, id: resultText?._id }))
      .unwrap()
      .then(() => {
        // success
        setSelectedWeight("");
      })
      .catch((error) => alert(error || "Failed to Update ShipmentCost."));
  };

  const headers = ["ID", "Country", "Cost"];

  // console.log("Zone "+zone)
  // console.log(selectedWeight)
  return (
    <div className="mx-auto overflow-x-auto rounded-xl">
      {/* Title */}
      <div className="flex items-center justify-between mx-5 my-4">
        <h1 className="text-xl font-bold text-black">Shipping Companies</h1>

        <div>
          <div className="flex flex-wrap gap-3 ">
            {/* Company */}
            <select
              className="p-2 text-black bg-white border rounded-md disabled:bg-gray-700 disabled:text-gray-200"
              value={selectedCampany}
              onChange={(e) => {
                setSelectedCampany(e.target.value);
                setSelectedWeight("");
              }}
            >
              <option value="" className="text-black">
                Select Campany
              </option>
              {companies.map((option) => (
                <option
                  key={option.id}
                  value={option.name}
                  className="text-black"
                >
                  {option.name}
                </option>
              ))}
            </select>

            {/* Weight */}
            <select
              className="p-2 text-black bg-white border rounded-md disabled:bg-gray-700 disabled:text-gray-200"
              value={selectedWeight}
              onChange={(e) => {
                setSelectedWeight(e.target.value);
                setResultText("");
                setTableResultText(null);
                setEditableCountries(getMenuItemscountryTo());
              }}
              disabled={!selectedCampany}
            >
              <option value="-1" className="text-black">
                {t("Select Weight")}
              </option>
              {menuItemsWeights.map((option) => (
                <option
                  key={option.id}
                  value={option.id}
                  className="text-black"
                >
                  {option.name}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      {selectedWeight === "31" && (
        <p className="px-4 py-2 mb-4 text-sm text-yellow-700 bg-yellow-100 border border-yellow-300 rounded">
          ⚠️ {t("shippingWeightNote")}
        </p>
      )}

      {selectedWeight && selectedCampany ? (
        <>
          {resultText ? (
            <>
              {/* Table */}
              <table className="w-full my-5">
                <thead>
                  <tr className="text-sm text-black bg-custom-yellow">
                    {headers.map((header, index) => (
                      <th
                        key={index}
                        className="px-2 py-2 font-bold text-center"
                      >
                        {header}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {editableCountries?.map((country, index) => (
                    <ShippingCompaniesTableDetails
                      key={country.en || index}
                      index={index + 1}
                      details={{
                        country: country?.en,
                        cost: country?.cost || 0,
                      }}
                      onCostChange={(cost) => handleCostChange(index, cost)}
                    />
                  ))}
                </tbody>
              </table>

              {/* ubdate Button */}
              <div className="flex justify-end my-4">
                <button
                  className="px-4 py-2 font-semibold text-white rounded bg-custom-yellow hover:bg-yellow-600"
                  onClick={handleSubmitUpdate}
                >
                  {t("update")}
                </button>
              </div>
            </>
          ) : (
            <>
              {/* Table */}
              <table className="w-full my-5">
                <thead>
                  <tr className="text-sm text-black bg-custom-yellow">
                    {headers.map((header, index) => (
                      <th
                        key={index}
                        className="px-2 py-2 font-bold text-center"
                      >
                        {header}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {editableCountries.map((country, index) => (
                    <ShippingCompaniesTableDetails
                      key={country.en || index}
                      index={index + 1}
                      details={{
                        country: country?.en,
                        cost: country?.cost || 0,
                      }}
                      onCostChange={(cost) => handleCostCreate(index, cost)}
                    />
                  ))}
                </tbody>
              </table>

              {/* Submit Button */}
              <div className="flex justify-end my-4">
                <button
                  className="px-4 py-2 font-semibold text-white rounded bg-custom-yellow hover:bg-yellow-600"
                  onClick={handleSubmitSend}
                >
                  {t("Send")}
                </button>
              </div>
            </>
          )}
        </>
      ) : (
        <div className="text-center text-red-300">
          Please select the company and weight
        </div>
      )}
    </div>
  );
};

export default ShippingCompaniesSettings;
